import { createContext, useContext } from 'react';

/**
 * Whether the chrome hosting this surface is currently showing it (架构方案
 * §5.7 视图缓存).
 *
 * A surface can be mounted and still be invisible: a kept-alive host keeps the
 * React tree (and the module activation behind it) alive while another one is on
 * screen. The editor's MRU cache expresses that per pane; a tabbed dockview area
 * expresses it per panel — activating a document tab hides its siblings, the
 * area anchor included, without unmounting anything. Both funnel into
 * `ViewProps.visible` so a view has one signal to pause polling / animation on.
 *
 * Defaults to `true`: a surface with no such host (overlay, detached window,
 * activityBar rail) is visible whenever it is mounted.
 */
export const HostVisibilityContext = createContext(true);

/** Read the hosting chrome's visibility; `true` outside any such host. */
export function useHostVisible(): boolean {
  return useContext(HostVisibilityContext);
}
